__turbopack_context__.v({
  "heading": "PortableTextComponents-module__yTCaaq__heading",
  "list": "PortableTextComponents-module__yTCaaq__list",
  "listItem": "PortableTextComponents-module__yTCaaq__listItem",
  "listItemNumber": "PortableTextComponents-module__yTCaaq__listItemNumber",
  "listNumber": "PortableTextComponents-module__yTCaaq__listNumber",
  "paragraph": "PortableTextComponents-module__yTCaaq__paragraph",
  "portableText": "PortableTextComponents-module__yTCaaq__portableText",
});
